export default __webpack_public_path__ + "static/media/waste-water.6f5107f4.webp";